module.exports = __webpack_public_path__ + "img/header-diamondJewelryPresentsYearly.0bdf94a.jpg";